import { ThemeConfig } from "bumbag";

const theme: ThemeConfig = {
  icons: {
    icons: {
      receiver: {
        viewBoxWidth: 141.7,
        viewBoxHeight: 141.7,
        paths: [
          `M111.4,49.1H98.6c-2.7-4-7.3-6.6-12.4-6.6H75.3V6c0-2.4-2-4.4-4.4-4.4s-4.4,2-4.4,4.4v36.5H56.5
          c-5.1,0-9.7,2.6-12.4,6.6H30.5c-8.2,0-15,6.7-15,15v61.1c0,8.2,6.7,15,15,15h80.9c8.2,0,15-6.7,15-15V64.1
          C126.4,55.8,119.6,49.1,111.4,49.1z M45.9,106.5c-9.6,0-17.4-7.8-17.4-17.4c0-9.6,7.8-17.4,17.4-17.4c9.6,0,17.4,7.8,17.4,17.4
          C63.3,98.7,55.5,106.5,45.9,106.5z M95.3,106.5c-9.6,0-17.4-7.8-17.4-17.4c0-9.6,7.8-17.4,17.4-17.4s17.4,7.8,17.4,17.4
          C112.7,98.7,104.9,106.5,95.3,106.5z`,
        ],
      },
      "acc-sensor": {
        viewBoxWidth: 30,
        viewBoxHeight: 25,
        paths: [
          `M 17.035156 3.582031 L 19.074219 7.164062 L 10.917969 7.164062 L 14.996094 0 Z M 17.035156 3.582031`,
          `M 26.785156 21.160156 L 28.824219 24.742188 L 20.667969 24.742188 L 24.746094 17.578125 Z M 26.785156 21.160156 `,
          `M 7.164062 21.160156 L 9.203125 24.742188 L 1.046875 24.742188 L 5.125 17.578125 Z M 7.164062 21.160156 `,
          `M 6.292969 20.039062 L 14.859375 15.09375 L 16.144531 17.324219 L 7.582031 22.269531 Z M 6.292969 20.039062 `,
          `M 16.28125 6.867188 L 16.285156 16.757812 L 13.710938 16.757812 L 13.707031 6.867188 Z M 16.28125 6.867188 `,
          `M 14.996094 15.09375 L 23.558594 20.039062 L 22.273438 22.269531 L 13.707031 17.324219 Z M 14.996094 15.09375 `,
        ],
      },
      "blackbox-log": {
        viewBoxWidth: 141.7,
        viewBoxHeight: 141.7,
        paths: [
          `M123.5,25.8h-6c-2.9,0-6.4,2.2-7.8,4.7L101.4,45c-1.7,3-4.9,4.4-8.3,4.4H46.2c-3.5,0-6.6-1.3-8.3-4.3
            l-8.3-14.9c-1.4-2.5-4.9-4.4-7.8-4.4h-6c-7,0-12.2,5.9-12.2,12.9v63.4c0,7,5.2,12.9,12.2,12.9h107.8c7,0,13.9-5.9,13.9-12.9V38.8
            C137.4,31.8,130.5,25.8,123.5,25.8z M38,85.5c-5.2,0-9.5-4.3-9.5-9.5c0-5.2,4.3-9.5,9.5-9.5s9.5,4.3,9.5,9.5S43.3,85.5,38,85.5z
             M84.4,80.1c0,2.6-2.1,4.6-4.6,4.6H58.8c-2.5,0-4.6-2.1-4.6-4.6v-8.8c0-2.6,2.1-4.6,4.6-4.6h20.9c2.6,0,4.6,2.1,4.6,4.6V80.1z
             M100.6,85.5c-5.2,0-9.5-4.3-9.5-9.5c0-5.2,4.3-9.5,9.5-9.5c5.2,0,9.5,4.3,9.5,9.5S105.9,85.5,100.6,85.5z`,
          `M43.6,36.7c1.4,2.5,4.9,4.9,7.8,4.9h36.4c2.9,0,6.4-2.3,7.8-4.8l3.2-6.1c1.4-2.5,0.2-4.8-2.7-4.8h-53
            c-2.9,0-4.1,2.2-2.7,4.7L43.6,36.7z`,
        ],
      },
    },
  },
};

export default theme;
